module.exports = __webpack_public_path__ + "img/screenshot1.b7391655.svg";